import { render, staticRenderFns } from "./momentByImg.vue?vue&type=template&id=48958545&scoped=true"
import script from "./momentByImg.vue?vue&type=script&lang=js"
export * from "./momentByImg.vue?vue&type=script&lang=js"
import style0 from "./momentByImg.vue?vue&type=style&index=0&id=48958545&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48958545",
  null
  
)

export default component.exports